import { Action } from '@ngrx/store';
import { CrpRolesRequest } from 'store/models/crp.models';
import {
  GetPrimaryCrpRecordPayload, GetRecordOtherDataPayload, RecordOtherDataResponse, GetRecordPayload
} from 'store/models/record.models';

export enum RecordActionTypes {
  GET_RECORDS = 'GET_RECORDS',
  GET_RECORDS_SUCCESS = 'GET_RECORDS_SUCCESS',
  GET_RECORDS_FAILURE = 'GET_RECORDS_FAILURE',

  GET_INDIVIDUAL_RECORD = 'GET_INDIVIDUAL_RECORD',
  GET_INDIVIDUAL_RECORD_SUCCESS = 'GET_INDIVIDUAL_RECORD_SUCCESS',
  GET_INDIVIDUAL_RECORD_FAILURE = 'GET_INDIVIDUAL_RECORD_FAILURE',

  GET_CORPORATE_RECORD = 'GET_CORPORATE_RECORD',
  GET_CORPORATE_RECORD_SUCCESS = 'GET_CORPORATE_RECORD_SUCCESS',
  GET_CORPORATE_RECORD_FAILURE = 'GET_CORPORATE_RECORD_FAILURE',

  GET_PRIMARY_CRP_RECORD = 'GET_PRIMARY_CRP_RECORD',
  CLEAR_GET_PRIMARY_CRP_RECORD = 'CLEAR_GET_PRIMARY_CRP_RECORD',

  ADD_CRP_ROLE = 'ADD_CRP_ROLE',
  ADD_CRP_ROLE_SUCCESS = 'ADD_CRP_ROLE_SUCCESS',
  ADD_CRP_ROLE_FAILURE = 'ADD_CRP_ROLE_FAILURE',

  DELETE_CRP = 'DELETE_CRP',
  DELETE_CRP_SUCCESS = 'DELETE_CRP_SUCCESS',
  DELETE_CRP_FAILURE = 'DELETE_CRP_FAILURE',

  DELETE_ROLE = 'DELETE_ROLE',
  DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS',
  DELETE_ROLE_FAILURE = 'DELETE_ROLE_FAILURE',

  GET_CRP_ROLES = 'GET_CRP_ROLES',
  GET_CRP_ROLES_SUCCESS = 'GET_CRP_ROLES_SUCCESS',
  GET_CRP_ROLES_FAILURE = 'GET_CRP_ROLES_FAILURE',
  RESET_RECORD = 'RESET_RECORD',

  GET_OTHER_DATA = 'GET_OTHER_DATA',
  GET_OTHER_DATA_SUCCESS = 'GET_OTHER_DATA_SUCCESS',
  GET_OTHER_DATA_FAILURE = 'GET_OTHER_DATA_FAILURE'
}

export class GetRecords implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.GET_RECORDS;
  constructor(public payload: any = null) { }
}

export class GetRecordsSuccess implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.GET_RECORDS_SUCCESS;
  constructor(public payload: any = null) { }
}

export class GetRecordsFailure implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.GET_RECORDS_FAILURE;
  constructor(public payload: any = null) { }
}

export class GetIndividualRecord implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.GET_INDIVIDUAL_RECORD;
  constructor(public payload: GetRecordPayload = null) { }
}

export class GetIndividualRecordSuccess implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.GET_INDIVIDUAL_RECORD_SUCCESS;
  constructor(public payload: any = null) { }
}

export class GetIndividualRecordFailure implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.GET_INDIVIDUAL_RECORD_FAILURE;
  constructor(public payload: any = null) { }
}

export class GetCorporateRecord implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.GET_CORPORATE_RECORD;
  constructor(public payload: GetRecordPayload = null) { }
}

export class GetCorporateRecordSuccess implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.GET_CORPORATE_RECORD_SUCCESS;
  constructor(public payload: any = null) { }
}

export class GetCorporateRecordFailure implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.GET_CORPORATE_RECORD_FAILURE;
  constructor(public payload: any = null) { }
}

export class GetPrimaryCrpRecord implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.GET_PRIMARY_CRP_RECORD;
  constructor(public payload: GetPrimaryCrpRecordPayload = null) { }
}

export class ClearGetPrimaryCrpRecord implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.CLEAR_GET_PRIMARY_CRP_RECORD;
  constructor(public payload: any = null) { }
}

export class AddCrpRole implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.ADD_CRP_ROLE;
  constructor(public payload: any = null) { }
}

export class AddCrpRoleSuccess implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.ADD_CRP_ROLE_SUCCESS;
  constructor(public payload: any = null) { }
}

export class AddCrpRoleFailure implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.ADD_CRP_ROLE_FAILURE;
  constructor(public payload: any = null) { }
}

export class DeleteCrp implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.DELETE_CRP;
  constructor(public payload: any = null) { }
}

export class DeleteCrpSuccess implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.DELETE_CRP_SUCCESS;
  constructor(public payload: any = null) { }
}

export class DeleteCrpFailure implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.DELETE_CRP_FAILURE;
  constructor(public payload: any = null) { }
}

export class DeleteRole implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.DELETE_ROLE;
  constructor(public payload: number = null) { }
}

export class DeleteRoleSuccess implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.DELETE_ROLE_SUCCESS;
  constructor(public payload: any = null) { }
}

export class DeleteRoleFailure implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.DELETE_ROLE_FAILURE;
  constructor(public payload: any = null) { }
}

export class GetCrpRoles implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.GET_CRP_ROLES;
  constructor(public payload: CrpRolesRequest = null) { }
}

export class GetCrpRolesSuccess implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.GET_CRP_ROLES_SUCCESS;
  constructor(public payload: any = null) { }
}

export class GetCrpRolesFailure implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.GET_CRP_ROLES_FAILURE;
  constructor(public payload: any = null) { }
}

export class ResetRecord implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.RESET_RECORD;
  constructor(public payload: any = null) { }
}

export class GetOtherData implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.GET_OTHER_DATA;
  constructor(public payload: GetRecordOtherDataPayload = null) { }
}

export class GetOtherDataSuccess implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.GET_OTHER_DATA_SUCCESS;
  constructor(public payload: RecordOtherDataResponse = null) { }
}

export class GetOtherDataFailure implements Action {
  readonly type: RecordActionTypes = RecordActionTypes.GET_OTHER_DATA_FAILURE;
  constructor(public payload: any = null) { }
}

export type RecordActions =
  | GetRecords
  | GetRecordsSuccess
  | GetRecordsFailure
  | GetIndividualRecord
  | GetIndividualRecordSuccess
  | GetIndividualRecordFailure
  | GetCorporateRecord
  | GetCorporateRecordSuccess
  | GetCorporateRecordFailure
  | AddCrpRole
  | AddCrpRoleSuccess
  | AddCrpRoleFailure
  | DeleteRole
  | DeleteRoleSuccess
  | DeleteRoleFailure
  | DeleteCrp
  | DeleteCrpSuccess
  | DeleteCrpFailure
  | GetCrpRoles
  | GetCrpRolesSuccess
  | GetCrpRolesFailure
  | ResetRecord
  | GetOtherData
  | GetOtherDataSuccess
  | GetOtherDataFailure
  ;
